import Vue from 'vue'
import App from './App.vue'
import router from './router';
import "../src/assets/style/reset.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import request from "./utils/request.js"
Vue.prototype.$http = request
Vue.use(ElementUI);


Vue.config.productionTip = false

new Vue({
	el: '#app',
	router,
  render: h => h(App)
}).$mount('#app')
